import { jsxs as _, jsx as d } from "react/jsx-runtime";
import { MessagingBlock as N } from "@strata/react-messaging-block";
import { StatusIcon as u } from "@strata/react-status-icons";
import { Tooltip as n } from "@strata/react-tooltip";
import i from "classnames";
import "./main.scss";
const a = {
  CAUTION: "caution",
  GOOD: "good",
  IN_PROGRESS: "in-progress",
  WARNING: "warning"
}, I = {
  [a.CAUTION]: n.Intent.ERROR,
  [a.GOOD]: n.Intent.SUCCESS,
  [a.IN_PROGRESS]: void 0,
  [a.WARNING]: n.Intent.WARNING
}, O = ({
  headerLeftContent: r = void 0,
  headerRightContent: t = void 0,
  bodyContent: p = void 0,
  rows: l = [],
  footerContent: g = void 0,
  cardStatus: s = void 0,
  cardStatusTooltipMap: m = void 0,
  showStatusIcon: c = !1,
  iconStatus: v = void 0,
  overlay: e = void 0,
  className: h = void 0
}) => /* @__PURE__ */ _("div", { className: i("sds_card", h), children: [
  e && /* @__PURE__ */ d("div", { className: "sds_card__overlay padding__around--medium", children: /* @__PURE__ */ d(
    N,
    {
      size: N.Sizes.SMALL,
      icon: e.icon,
      primaryText: e.primaryText,
      secondaryText: e.secondaryText
    }
  ) }),
  /* @__PURE__ */ _("div", { className: "sds_card__shadow", children: [
    s && m ? /* @__PURE__ */ d(
      n,
      {
        content: m[s],
        intent: I[s],
        className: i("sds_card__status", {
          [`sds_card__status--${s}`]: s
        }),
        children: /* @__PURE__ */ d("div", { className: "padding__left--small" })
      }
    ) : /* @__PURE__ */ d(
      "div",
      {
        className: i(
          {
            "padding__left--small": s,
            [`sds_card__status--${s}`]: s
          },
          "sds_card__status"
        )
      }
    ),
    /* @__PURE__ */ _("div", { className: "sds_card__content", children: [
      /* @__PURE__ */ _(
        "div",
        {
          className: i(
            "sds_card__header",
            "padding__top--small",
            "padding__right--medium",
            "padding__bottom--small",
            `padding__left--${c ? "x-large" : "medium"}`
          ),
          children: [
            r && /* @__PURE__ */ d(
              "div",
              {
                className: i("sds_card__header__left-content", {
                  "padding__left--small": c
                }),
                children: r
              }
            ),
            t && /* @__PURE__ */ d("div", { className: "sds_card__header__right-content margin__left--small", children: t })
          ]
        }
      ),
      /* @__PURE__ */ _("div", { className: "sds_card__body padding__around--medium", children: [
        c && /* @__PURE__ */ d(
          u,
          {
            status: v,
            showEmptyCircle: !0,
            size: 20,
            className: "sds_card__body__status-icon padding__right--medium"
          }
        ),
        /* @__PURE__ */ d("div", { className: "sds_card__body__content", children: p })
      ] }),
      g
    ] })
  ] }),
  l.length > 0 && /* @__PURE__ */ d("div", { className: "sds_card__row-container", children: l.map((o, f) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ _("div", { className: "sds_card__row padding__around--medium", children: [
      /* @__PURE__ */ d("div", { className: "sds_card__row__left-content", children: o.leftContent }),
      /* @__PURE__ */ d("div", { className: "sds_card__row__right-content", children: o.rightContent })
    ] }, f)
  )) })
] });
O.Statuses = a;
export {
  O as Card
};
//# sourceMappingURL=index.js.map
